(function () {
  function slugify(value) {
    return value
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function uniqueId(base, usedIds) {
    var candidate = base || 'section';
    var suffix = 2;

    while (usedIds.has(candidate) || document.getElementById(candidate)) {
      candidate = (base || 'section') + '-' + suffix;
      suffix += 1;
    }

    usedIds.add(candidate);
    return candidate;
  }

  function enhanceInformationPage(root) {
    var kind = root.dataset.infoKind;
    var body = root.querySelector('[data-info-page-body]');
    var toc = root.querySelector('[data-info-page-toc]');
    var tocDisclosure = root.querySelector('.info-page__toc-disclosure');

    if (tocDisclosure && window.matchMedia('(max-width: 960px)').matches) {
      tocDisclosure.removeAttribute('open');
    }

    if (!body) {
      body = root.querySelector('.shopify-policy__body .rte');
      if (body) body.setAttribute('data-info-page-body', '');
    }

    if (!body || !toc) return;

    var headings = [];

    if (kind === 'terms') {
      headings = Array.from(body.querySelectorAll('strong')).filter(function (heading) {
        return /^(overview|section\s+\d+\s*[-\u2013\u2014])/i.test(heading.textContent.trim());
      });

      headings.forEach(function (heading) {
        heading.classList.add('info-page__generated-heading');
        heading.setAttribute('role', 'heading');
        heading.setAttribute('aria-level', '2');
      });
    } else {
      headings = Array.from(body.querySelectorAll('h2'));
      var firstH2 = headings[0];
      var firstH3 = body.querySelector('h3');

      if (firstH3 && (!firstH2 || firstH3.compareDocumentPosition(firstH2) & Node.DOCUMENT_POSITION_FOLLOWING)) {
        headings.unshift(firstH3);
      }
    }

    if (!headings.length) {
      root.classList.add('info-page--no-toc');
      return;
    }

    var usedIds = new Set();
    var links = [];

    headings.forEach(function (heading) {
      var label = heading.textContent.trim().replace(/:$/, '');
      var id = heading.id || uniqueId(slugify(label), usedIds);
      heading.id = id;

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = label;
      item.appendChild(link);
      toc.appendChild(item);
      links.push(link);
    });

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries
          .filter(function (entry) { return entry.isIntersecting; })
          .sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });

        if (!visible.length) return;

        var activeId = visible[0].target.id;
        links.forEach(function (link) {
          var active = link.getAttribute('href') === '#' + activeId;
          link.classList.toggle('is-active', active);
          if (active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      },
      { rootMargin: '-18% 0px -72% 0px', threshold: 0 }
    );

    headings.forEach(function (heading) { observer.observe(heading); });
  }

  function init() {
    document.querySelectorAll('[data-info-page]').forEach(enhanceInformationPage);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
